export class CycleCountItemResponse {


  Group: string;

  GroupQty: string;

  SKU: string;

  Desc: string;

  QtyOnHand: string;

  UPC: string;

  EPC: string;

  fromArray(objectArray: Array<string>): CycleCountItemResponse {
    this.Group = objectArray[0];
    this.GroupQty = objectArray[1];
    this.SKU = objectArray[2];
    this.Desc = objectArray[3];
    this.QtyOnHand = objectArray[4];
    this.UPC = objectArray[5];
    this.EPC = objectArray[6];
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/models/CycleCountItemResponse.ts